export default __webpack_public_path__ + "img/tremors/tremors1_480.jpg";